// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ReleaseNoteSearchResponse

import { hydrateReleaseNote, type ReleaseNote, type ReleaseNoteApiResponse } from './releaseNote.gen';

export type ReleaseNoteSearchApiResponse = {
	items: ReleaseNoteApiResponse[];
};

export type ReleaseNoteSearch = {
	items: ReleaseNote[];
};

export function hydrateReleaseNoteSearch(data: ReleaseNoteSearchApiResponse): ReleaseNoteSearch {
	return {
		...data,
		items: data.items.map(hydrateReleaseNote),
	};
}